import { useState } from 'react';
import { PrimaryButton } from '@/lib';
import { useCreateInvitation } from '../queries';

const ROLES = ['viewer', 'maintainer', 'manager', 'admin'] as const;

export function InviteStep({ onCompleted }: { onCompleted: () => void }) {
  const create = useCreateInvitation();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<(typeof ROLES)[number]>('maintainer');
  const [sent, setSent] = useState<string[]>([]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    await create.mutateAsync({ email: email.trim(), role });
    setSent((prev) => [...prev, email.trim()]);
    setEmail('');
    onCompleted();
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-sp-4">
      <p className="text-fs-body text-gray-700">
        Invite the team. They'll get a /invite?token=... link that
        sets up their account in your tenant.
      </p>

      {sent.length > 0 ? (
        <ul className="flex flex-wrap gap-sp-2 font-mono text-fs-meta">
          {sent.map((e) => (
            <li
              key={e}
              className="rounded-r-chip bg-healthy-bg px-sp-2 py-sp-1 text-healthy-fg"
            >
              ✓ {e}
            </li>
          ))}
        </ul>
      ) : null}

      <label className="flex flex-col gap-sp-1 text-fs-body text-gray-900">
        Email
        <input
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="teammate@example.com"
          className="rounded-r-default border border-gray-300 bg-gray-50 px-sp-2 py-sp-1"
        />
      </label>
      <label className="flex flex-col gap-sp-1 text-fs-body text-gray-900">
        Role
        <select
          value={role}
          onChange={(e) => setRole(e.target.value as typeof role)}
          className="rounded-r-default border border-gray-300 bg-gray-50 px-sp-2 py-sp-1"
        >
          {ROLES.map((r) => (
            <option key={r}>{r}</option>
          ))}
        </select>
      </label>
      <div className="flex items-center gap-sp-3">
        <PrimaryButton
          type="submit"
          label={create.isPending ? 'Sending…' : 'Send invite'}
          disabled={create.isPending}
        />
        {create.isError ? (
          <span role="alert" className="text-fs-meta text-critical">
            {String(create.error)}
          </span>
        ) : null}
      </div>
    </form>
  );
}
